import Service from "../../Service";
const resource = "HmnAttendanceRemote/";

export default {

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    list(parameters,requestID) {
        return Service.post(resource + "list", parameters, {
            params: { requestID: requestID },
        });
    },
    save(parameters,requestID) {
        return Service.post(resource + "save", parameters, {
            params: { requestID: requestID },
        });
    },
    listValidation(parameters,requestID) {
        return Service.post(resource + "listValidation", parameters, {
            params: { requestID: requestID },
        });
    },
    listApproval(parameters,requestID) {
        return Service.post(resource + "listApproval", parameters, {
            params: { requestID: requestID },
        });
    },
    listMarking(parameters,requestID) {
        return Service.post(resource + "listMarking", parameters, {
            params: { requestID: requestID },
        });
    },
    SeeValidations(parameters,requestID) {
        return Service.post(resource + "SeeValidations", parameters, {
            params: { requestID: requestID },
        });
    },
};